export const pipeTxChallenge = ({
  paymentType, isIban=true,
  executionDate, amount, remarks, businessUnitBankDate,
  from, to, currency, cost, orderId, versionId, externalOrderId    // objects
}) => {
  const isInternal = paymentType.includes('internal')
  // const isInternational = paymentType.includes('international')
  // const isDomestic = paymentType.includes('dom')
  // const isSEPA = paymentType.includes('sepa')
  const payment = {
    executionDate,
    amount,
    remarks,
    businessUnitBankDate,
    currency,
    fromAccount: from,
    orderId,
    versionId,
    externalOrderId
  }
  if (isInternal) {
    payment.toAccount = {
      pfId: to.pfId,
      accNo: to.accNo,
      accName: to.accName,
      currency: to.currency,
      accBalance: to.accBalance,
      asOfDate: to.asOfDate,
      psPosId: to.psPosId,
    }
  } else {
    payment.toAccount = {
      accountKey: to.accountKey||to.beneficiaryId ||'',
      firstName: to.firstName||'',
      lastName: to.lastName||'',
      address1: to.address1 ||'',
      address2: to.address2 ||'',
      address3: to.address3 ||'',
      cityName: to.city||'',
      stateName: to.state||'',
      country: to.country||'',
      postalCode: to.postalCode||'',
      accountNo: to.accountNo||'',
      ibanNo: to.ibanNo||'',
      bankRefId: to.bankRefId||'',
      swiftCode: to.swiftCode||'',
      ntnlId: to.ntnlId||'',
      sortCode: to.sortCode||'',
      bank: to.bank||'',
      accountType: to.accountType
    }
    payment.chargeOption = {
      costType: cost.costType,
      costDesc: cost.ebLabelDesc,
      costId: cost.displayOrder,
    }
  }
  return payment
}
const getBeneficiaryName = toAccount => {
  const { firstName, lastName } = toAccount
  return (firstName||'')+(firstName&&lastName?' ':'')+(lastName||'')
}
const serializeSummary = ({ 
  paymentType, 
  signingType,
  approvalExpiryTs,
  approvalHistory,
  rejectionReason,
  fromAccount, toAccount, currency, // objects
  amount, executionDate, remarks, status, valueDate='', uuid, modifiedTs, txToken, chargeDesc, sortCode,transactionFee,forexText, statusCode
}) => {
  const isInternal = paymentType.includes('internal')
  const isInternational = paymentType.includes('international')
  const isDomestic = paymentType.includes('dom')
  const isSepa = paymentType.includes('sepa')
  const isQrBillPayment= paymentType.includes('swissqrbill')

  const tx = {
    // from 
    pfId: fromAccount.pfId,
    accName: fromAccount.accName,
    accNo: fromAccount.accNo,
    accBal: fromAccount.accBalance,
    accBalCode: fromAccount.currency,
    asOfDate: fromAccount.asOfDate,
    // general
    currencyAmountCode: currency.tech,
    currencyAmount: amount,
    executionDate,
    remarks,
    sortCode,
    valueDate,
    status,
    uuid, 
    modifiedTs,
    txToken,
    transactionFee,
    forexText,
    // action
    signingType,
    approvalExpiryTs,
    approvalHistory,
    rejectionReason,
    editable: false,
    cancelable: false,
    confirmable: false,
    statusCode
  }
  if (isInternal) {
    Object.assign(tx, {
      beneficiaryName: toAccount.accName,
      ibanNo: toAccount.accNo,
      swiftCode: toAccount.pfId,
    })
  } else {
    Object.assign(tx, {
      beneficiaryName: getBeneficiaryName(toAccount),
      swiftCode: toAccount.swiftCode,
      ntnlId: toAccount.ntnlId,
      // fallback for international without ibanNo
      ibanNo: toAccount.ibanNo || toAccount.accountNo,
      bankName: toAccount.bank || '',
      address1: toAccount.address1,
      address2: toAccount.address2,
      address3: toAccount.address3
    })
  }
  if (isInternational || isDomestic || isSepa || isQrBillPayment) {
    tx.costs = chargeDesc
  }
  return tx
}
/**
 * @Description
 * @param paymentType[String]
 * @param challenge[Object]: result of pipeTxChallenge
 * @param data[Object]: returned object of api 'generateTxChallenge' or 'fetchTx'
 * @param type[String]: api name, default='generateTxChallenge'
 */
export const pipeSummary = ({ paymentType, challenge, data, txToken, chargeDesc='', type='generateTxChallenge', externalOrderId }) => {
  let tx
  const isInternal = paymentType.includes('internal')
  const isInternational = paymentType.includes('international')
  const isSepa = paymentType.includes('sepa')
  
  if (type==='generateTxChallenge') {
    var paymentDetails = data.paymentDetails;
    if(isSepa){
      paymentDetails = data.sepaPaymentDetails;
    }else if(isInternational){
      paymentDetails = data.internationalPaymentDetails;
    }else if(isInternal){
      paymentDetails = data.internalpaymentDetails;
    }
    console.log('----->>>>> 8', data)
    const {
      valueDate='', 
      paymentStatus,
      sortCode,
      uuid,
      modifiedTs,
      approvalExpiryTs,
      signingType
      } = data
      const {
        remarks,
        transactionFee,
        forexText
      } = paymentDetails
    const { 
      fromAccount, toAccount, currency, 
      // chargeOption, // undefined for internal/SEPA
      amount, executionDate,
    } = challenge
    const status = paymentStatus && paymentStatus.statusDescription;
    const statusCode = paymentStatus && paymentStatus?.dwoStatus || '';

    tx = serializeSummary({
      paymentType,
      signingType,
      approvalExpiryTs,
      fromAccount, toAccount, currency, 
      amount, executionDate, remarks, status, valueDate, uuid, modifiedTs, txToken, chargeDesc, sortCode,transactionFee,forexText,
      statusCode
    })
    tx.externalOrderId = externalOrderId
    if (data.dwoMessage && data.dwoMessage.messages) {
      const messages = data.dwoMessage.messages
      const isBlocking = messages.some(err => err.sevType==='Blocking')
      const isResolvable = messages.some(err => err.errorType==='Error'&&(err.sevType==='Recoverable'||err.sevType==='Resolvable'))
      if (isBlocking || isResolvable) {
        tx.confirmable = false
      } else {
        tx.confirmable = true
      }
    } else {
      tx.confirmable = true
    }
    // WMCE-52195 - Payment summary screen always includes the "Modify" & "Discard" action
    tx.editable = true;
    tx.cancelable = true;
  } else if (type==='fetchTx') {
    const isInternal = paymentType.includes('internal')
    const toAccount = isInternal ? data.creditAccountDetails : data.beneficiaryDetails
    const {
      cashAccountDetails: fromAccount,
      currency,
      amount, remarks='', executionDate, valueDate='',
      modifyEnable, deleteEnable, sortCode, transactionFee
    } = data
    const status = data.paymentStatus ? data.paymentStatus.statusDescription : 'Pending'
    tx = serializeSummary({
      paymentType,
      fromAccount, toAccount, currency,
      amount, executionDate, remarks, status, valueDate, txToken, chargeDesc, sortCode
    })
    tx.orderId = data.orderId || data.id
    tx.versionId = data.versionId
    tx.id = data.id
    tx.externalOrderId = data.externalOrderId
    tx.sortCode = data.sortCode,
    tx.transactionFee = data.transactionFee
    // if (data.dwoinitiated) {
    //   const { dwoStatus } = data.paymentStatus
      
    //     Discarded     Readonly
    //     Cancelled     Readonly
    //     Pending       Modify, Cancel
    //     Processing    Cancel
    //     Done          Readonly
      
    //   if (/processing/i.test(dwoStatus)) {
    //     tx.cancelable = true
    //   } else if (/pending/i.test(dwoStatus)) {
    //     tx.editable = true
    //     tx.cancelable = true
    //   } 
    // } 
    if(modifyEnable){
      tx.editable = true
    }
    if(deleteEnable){
      tx.cancelable = true
    } 
  } else if (type === 'txForMultisign'){
      var paymentDetails = data.paymentDetails; // for domestic payments
      if(isSepa){
        paymentDetails = data.sepaPaymentDetails;
      }else if(isInternational){
        paymentDetails = data.internationalPaymentDetails;
      }else if(isInternal){
        paymentDetails = data.internalpaymentDetails;
      }
      console.log('----->>>>> 9', data)
      const {
        valueDate='', 
        paymentStatus,
        sortCode,
        uuid,
        modifiedTs,
        approvalExpiryTs,
        approvalHistory,
        
        signingType
        } = data
        const {
          remarks,
          transactionFee,
          forexText
        } = paymentDetails
        
      const { 
        fromAccount, toAccount, currency, 
        // chargeOption, // undefined for internal/SEPA
        amount, executionDate,
      } = paymentDetails
      const status = paymentStatus && paymentStatus.statusDescription;
      const statusCode = paymentStatus && paymentStatus?.code || '';

      const chargeDesc = paymentDetails && paymentDetails.chargeOption && paymentDetails.chargeOption.ebLabelDesc;
      tx = serializeSummary({
        paymentType,
        fromAccount, toAccount, currency, 
        signingType,
        approvalExpiryTs,
        approvalHistory,
        amount, executionDate, remarks, status, valueDate, uuid, modifiedTs, txToken, chargeDesc, sortCode,transactionFee,forexText,
        statusCode
      })
      tx.externalOrderId = externalOrderId
      if (data.dwoMessage && data.dwoMessage.messages) {
        const messages = data.dwoMessage.messages
        const isBlocking = messages.some(err => err.sevType==='Blocking')
        const isResolvable = messages.some(err => err.errorType==='Error'&&(err.sevType==='Recoverable'||err.sevType==='Resolvable'))
        if (isBlocking) {
          tx.editable = true
          tx.confirmable = false
          tx.cancelable = true
        } else if (isResolvable) {
          tx.editable = true
          tx.confirmable = false
          tx.cancelable = true
        } else {
          tx.confirmable = true
        }
      } else {
        tx.confirmable = true
      }

  } else if(type === 'txForViewMultisign'){
    const isInternal = paymentType.includes('internal')
    const toAccount = isInternal ? data.creditAccountDetails : data.beneficiaryDetails
    const {
      cashAccountDetails: fromAccount,
      currency,
      amount, remarks='', executionDate, valueDate='',
      modifyEnable, deleteEnable, sortCode, transactionFee,approvalExpiryTs,
      approvalHistory,
      rejectionReason
    } = data
    const status = data.signingStatus && data.signingStatus?.description || '';
    const statusCode = data.signingStatus && data.signingStatus?.code || '';
    tx = serializeSummary({
      paymentType,
      fromAccount, toAccount, currency,
      amount, executionDate, remarks, status, valueDate, txToken, chargeDesc, sortCode,
      approvalExpiryTs,
      approvalHistory,
      rejectionReason,
      statusCode
    })
    tx.orderId = data.orderId || data.id
    tx.versionId = data.versionId
    tx.id = data.id
    tx.externalOrderId = data.externalOrderId
    tx.sortCode = data.sortCode,
    tx.transactionFee = data.transactionFee
   
    if(modifyEnable){
      tx.editable = true
    }
    if(deleteEnable){
      tx.cancelable = true
    } 

  }
  return tx
}

export const pipeTemplate = ({
  selectedPaymentTemplate, templateName,paymentType, selectedDebitAcnt, selectedCurrency, amount, selectedBeneficiaryBank, 
  selectedCreditAcnt, remarks, selectedCost, payReasonKey
}) => {
  const finalObject = {
    templateId: selectedPaymentTemplate?selectedPaymentTemplate.templateId:null,
    templateName,
    paymentType,
    amount,
    currencyKey: selectedCurrency.currencyKey,
    currencyTech: selectedCurrency.tech,
    cashAccPfId:selectedDebitAcnt.pfId,
    cashAccNo: selectedDebitAcnt.accNo,
    remarks,
    beneficiaryId: selectedBeneficiaryBank && selectedBeneficiaryBank.beneficiaryId,
    toCashAccPfId: null,
    toCashAccNo: null,
    toCashAccIbanNo: null,
    costTypeKey:selectedCost && selectedCost.costTypeKey,
    payReasonKey
  }
  if(paymentType === 'internal-payments'){
    finalObject.beneficiaryId = null;
    finalObject.toCashAccPfId = selectedCreditAcnt.pfId;
    finalObject.toCashAccNo = selectedCreditAcnt.accNo;
    finalObject.toCashAccIbanNo = selectedCreditAcnt.accNo;
  }
  return finalObject;
}

export const toNumber = amt =>
          typeof amt === 'number' ? amt : Number(amt.replace(/[^0-9.]/g, ''))